
import React from 'react';
import Header from '../common/header';
import Footer from '../common/footer';
import TopBarPage from '../pages/TopBarPage';


const WebsiteLayout = ({ children }) => {
  return (
    <div>
      <TopBarPage />
      <Header />
      <div>{children}</div>
      <Footer />
    </div>
  );
};

export default WebsiteLayout;